module.exports = __webpack_public_path__ + "img/armezza.15b4b20a.svg";